import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SidebarComponent from '../common/sidebar-component';
import OrganisationResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import MicroWire from '../common/sidebar/micro-wire';
import useGetWiresMentioningOfOrganisation from '../../../services/wires/mention-of-organisation-service';

export default function MentionedWires({ organisation }) {
  const { dispatch } = React.useContext(OrganisationResultsContext);
  const [{ data }, executeQuery] = useGetWiresMentioningOfOrganisation(organisation, 3);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'wires.length')) {
      dispatch({ type: 'setMentionedWires', payload: data.wires });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'wires.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title={`${data.wires.length > 1 ? 'wires' : 'wire'} which mention`}
        query={organisation}
      />
      {data.wires.map(wire => <MicroWire key={`wire-${wire.id}`} wire={wire} />)}
    </SidebarComponent>
  );
}

MentionedWires.propTypes = {
  organisation: PropTypes.string.isRequired,
};
